import { RyeconClock } from '@dbt-labs/sourdough';

import DetailTabs, { TabInfo } from '@/components/DetailTabs';
import { useMetric } from '@/hooks/dbtStrategy/useMetric';
import { GenericResourceNode } from '@/hooks/discovery/types';
import { ParsedUniqueId } from '@/typings/parseUniqueId';
import {
  formatAbsoluteLocalDate,
  formatDateCommon,
} from '../../../../../../../util/date';
import {
  getResourceTypeHeaderIcon,
  ResourceDetailsHeader,
  TextIconPair,
} from '../Header';
import { GeneralView } from '../Tabs/GeneralView';

const tabs: TabInfo[] = [{ type: 'general' }];

type ResourceParams = {
  uniqueId: ParsedUniqueId;
};

export const MetricView = ({ uniqueId }: ResourceParams) => {
  const metricQuery = useMetric(uniqueId);

  if (metricQuery.error) return <>{metricQuery.error.stack}</>;
  const metric = (metricQuery.fetching ? null : metricQuery.data) ?? null;

  const lastUpdatedAtUnformatted = metric?.definition?.runGeneratedAt;
  const date = lastUpdatedAtUnformatted
    ? new Date(lastUpdatedAtUnformatted)
    : undefined;
  const updatedAt = date && formatAbsoluteLocalDate(date);
  const updatedAtUtc = date && formatDateCommon(date).utc;

  const headerIcons: TextIconPair[] = [getResourceTypeHeaderIcon('metric')];
  if (updatedAt) {
    headerIcons.push({
      ryecon: RyeconClock,
      text: `Definition updated as of ${updatedAt}`,
      tooltip: updatedAtUtc || undefined,
    });
  }

  return (
    <>
      <ResourceDetailsHeader
        uniqueId={uniqueId.raw}
        title={metric?.definition?.name ?? uniqueId.remainder}
        headerIcons={headerIcons}
        packageName={uniqueId.packageName}
        files={[metric?.definition?.patchPath, metric?.definition?.filePath]}
        name={metric?.definition?.name}
        resourceType="metric"
        updatedDate={date}
      />
      <DetailTabs tabs={tabs} show={!!metric}>
        {(activeTab) => {
          return (
            <>
              {activeTab === 'general' && (
                <>
                  <GeneralView
                    resource={metric?.definition as GenericResourceNode}
                    uniqueId={uniqueId}
                    description={metric?.definition?.description}
                    meta={metric?.definition?.meta}
                  />
                </>
              )}
            </>
          );
        }}
      </DetailTabs>
    </>
  );
};
